import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class AnnouncementService extends AbstractService {
	static endpoint = ENDPOINTS.announcements;

	static announcementsApi = NexusService.announcementsApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_announcements";

	static getAnnouncements({ pageNumber, displayCount }) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.announcementsApi
				.getPaginatedAnnouncements({ displayCount, pageNumber })
				.then(response => {
					const apiResponse = {
						data: {
							Count: response.Count,
							DisplayCount: response.DisplayCount,
							Page: response.Page,
							Total: response.Total,
							ItemList: response.ItemList.map(item => ({
								Id: item.Id,
								Subject: item.Subject,
								Body: item.Body,
								CreatedByUserId: item.CreatedByUserId,
								ActiveStartDateTime: item.ActiveStartDateTime?.toString(),
								ActiveEndDateTime: item.ActiveEndDateTime?.toString(),
								AudienceTypes: item.AudienceTypes,
								SeverityType: item.SeverityType,
								CreateDateUTC: item.CreateDateUTC?.toString(),
							})),
						},
					};

					return apiResponse;
				});
		}

		return this.get({
			endpoint: this.endpoint,
			queryParams: {
				pageNumber,
				displayCount,
			},
		});
	}

	static getAnnouncementById(id) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.announcementsApi
				.getAnnouncement({ id })
				.then(response => {
					const apiResponse = {
						data: {
							Id: response.Id,
							Subject: response.Subject,
							Body: response.Body,
							CreatedByUserId: response.CreatedByUserId,
							ActiveStartDateTime: response.ActiveStartDateTime?.toString(),
							ActiveEndDateTime: response.ActiveEndDateTime?.toString(),
							AudienceTypes: response.AudienceTypes,
							SeverityType: response.SeverityType,
						},
					};

					return apiResponse;
				})
				.catch(response => ({ error: response }));
		}

		return this.get({
			endpoint: `${this.endpoint}/${id}`,
		});
	}

	static saveAnnouncement({
		Id,
		Body,
		Subject,
		NeedNotification,
		AudienceTypes,
		ActiveStartDateTime,
		ActiveEndDateTime,
		SeverityType,
	}) {
		const isCreating = Id === null;

		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const req = {
				Subject,
				Body,
				SeverityType,
			};

			if (AudienceTypes != null) {
				req.AudienceTypes = AudienceTypes;
			}

			if (ActiveStartDateTime != null) {
				req.ActiveStartDateTime = new Date(ActiveStartDateTime);
			}

			if (ActiveEndDateTime != null) {
				req.ActiveEndDateTime = new Date(ActiveEndDateTime);
			}

			if (isCreating) {
				return this.announcementsApi
					.createAnnouncement({ announcementCreatePayload: req })
					.then(response => ({ data: response }));
			}

			return this.announcementsApi
				.updateAnnouncement({ id: Id, announcementUpdatePayload: req })
				.then(response => ({ data: response }));
		}

		const method = isCreating ? "POST" : "PUT";
		const { endpoint } = this;

		return this.request({
			endpoint,
			method,
			data: {
				Id,
				Body,
				Subject,
				AudienceTypes,
				ActiveStartDateTime,
				ActiveEndDateTime,
				SeverityType,
				NeedNotification,
			},
		});
	}

	static deleteAnnouncement(id) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.announcementsApi.deleteAnnouncement({ id });
		}

		return this.del({
			endpoint: `${this.endpoint}/${id}`,
		});
	}
}
